(() => {
  document.documentElement.classList.add('tx-premium-ready');
  const markExternal = () => document.querySelectorAll('a[target="_blank"]').forEach(link => {
    if (!link.rel.includes('noopener')) link.rel = `${link.rel} noopener noreferrer`.trim();
  });
  const labelProductForms = () => document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    if (!form.getAttribute('aria-label')) form.setAttribute('aria-label', 'Add product to cart');
  });
  document.addEventListener('DOMContentLoaded', () => { markExternal(); labelProductForms(); });
})();
